import HomePageView from '../views/HomePageView';

const HomePageContainer = () =>  {
  return (
    <HomePageView />
  );
};

export default HomePageContainer;